// Инициализация форм документа.

import Lightbox from '~/app/elements/Lightbox';

/**
 * Класс, назначаемый после успешной отправки формы.
 */
const CLASS_SUCCESS = 'success';
/**
 * Класс, назначаемый на время отправки формы.
 */
const CLASS_PROGRESS = 'progress';

/**
 * Инициализация форм документа.
 */
function main(): void
{
	for ( let i = 0, n = document.forms.length; i < n; i++ )
	{
		initForm( document.forms.item( i ) );
	}
}

/**
 * Инициализация формы.
 */
function initForm( form: HTMLFormElement ): void
{
	if ( form.dataset.ajax !== 'true' )
	{
		return;
	}
	
	const btnSubmit = form.querySelector( 'button[type="submit"]' ) as HTMLButtonElement;
	
	if ( !btnSubmit )
	{
		return;
	}
	
	const btnOk = form.querySelector( 'div.success button' ) as HTMLButtonElement;
	const lightbox = Lightbox.instance;
	
	if ( btnOk )
	{
		btnOk.addEventListener(
			'click',
			(): void =>
			{
				lightbox.close();
				form.classList.remove( CLASS_SUCCESS );
			},
		);
	}
	
	form.addEventListener(
		'submit',
		( event: Event ) =>
		{
			event.preventDefault();
			
			const xhr = new XMLHttpRequest();
			const data = new FormData( form );
			
			data.append( 'pageUrl', window.location.href );
			
			btnSubmit.blur();
			
			xhr.onload = (): void =>
			{
				form.classList.remove( CLASS_PROGRESS );
				
				if ( xhr.status < 400 )
				{
					form.classList.add( CLASS_SUCCESS );
				}
			};
			
			form.classList.add( CLASS_PROGRESS );
			
			xhr.open( 'POST'/*form.method*/, form.action );
			xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
			xhr.send( data );
			
			if ( form.dataset.tracking )
			{
				try
				{
					// tslint:disable-next-line:no-non-null-assertion
					const trackingData = JSON.parse( form.dataset.tracking! );
					
					if ( Array.isArray( trackingData ) )
					{
						sendTracking( trackingData );
					}
				}
				catch ( error )
				{
					console.error( error );
				}
			}
		},
	);
}

/**
 * Отправляет данные отслеживания.
 * 
 * @param data Данные события.
 */
function sendTracking( data: string[] ): void
{
	const ga = (window as any).ga;
	
	if ( !ga )
	{
		return;
	}
	
	ga.apply(
		null,
		[
			ga.getAll()[0].get( 'name' ) + '.send',
			...data,
		],
	);
}

/**
 * Module.
 */
export {
	main as default,
};



// WEBPACK FOOTER //
// ./app/Common/Forms/index.ts